import React from 'react'
import {FaGithub, FaLinkedin} from 'react-icons/fa'
import {HiOutlineMail} from 'react-icons/hi'
import {BsFillPersonLinesFill} from 'react-icons/bs'
import { SiLeetcode, SiGeeksforgeeks } from 'react-icons/si';

const SocialLinks = () => {
    const links = [
        {
            id: 1,
            child: (
                <> LinkedIn <FaLinkedin size={30} /> </>
            ), 
            href: "https://www.linkedin.com/in/yogendra30/",
            style: "rounded-tr-md" 
        },
        {
            id: 2,
            child: (
                <> GitHub <FaGithub size={30} /> </>
            ), 
            href: "https://github.com/yogi03",
        },
        {
            id: 3,
            child: (
                <> LeetCode <SiLeetcode size={30} /> </>
            ),
            href: "https://leetcode.com/u/yogi30/",
        },
        {
          id: 4,
          child: (
              <> GfG &nbsp; <SiGeeksforgeeks size={30} /> </>
          ),
          href: "https://www.geeksforgeeks.org/user/tusharchaurasiya/",
        },
        {
            id: 5,
            child: (
                <> Mail <HiOutlineMail size={30} /> </>
            ), 
            href: "mailto:yogendrachaurasiya30@gmail.com",
        },
        {
            id: 6,
            child: (
                <> Resume <BsFillPersonLinesFill size={30} /> </>
            ), 
            href: "/yogendra_resume.pdf",
            style: "rounded-br-md",
            download: true, 
        },
        

    ]

  return (
    <div className='hidden lg:flex flex-col top-[28%] left-0 fixed'>
        <ul>
            {links.map(({id, child, href, style, download}) => (
                <li key={id} className={`flex justify-between items-center w-40 h-14 px-4 ml-[-100px] hover:ml-[-10px] hover:rounded-md duration-300 bg-gray-800 ${style}`}>
                    <a href={href} className='flex justify-between items-center w-full text-white' download={download} target='_blank' rel='noreferrer'> {child} </a>
                </li>
            ))}
            
        </ul>
    </div>
  )
}

export default SocialLinks
